/**
 * Kurpfalz Automation — wordmark logo.
 * Uses the official logo file (public/logo-kurpfalz-automation.png) instead of
 * a generated mark, so header/footer match the real brand asset.
 */
export const KurpfalzLogo = ({ dark = false, className = "" }) => {
  return (
    <div className={`flex items-center ${className}`} aria-label="Kurpfalz Automation">
      <img
        src="/logo-kurpfalz-automation.png"
        alt="Kurpfalz Automation"
        className={`h-9 sm:h-10 w-auto shrink-0 ${dark ? "brightness-0 invert" : ""}`}
      />
    </div>
  );
};

export default KurpfalzLogo;
